import React, { useEffect, useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { v4 as uuidv4 } from "uuid";
const AuthModal = ({ setOpen }) => {
  const [authName, setAuthName] = useState("");
  useEffect(() => {
    setAuthName(`${uuidv4()} Mailchimp account`);
  }, []);

  const AuthHandler = () => {
    window.open('https://login.mailchimp.com/oauth2/authorize?response_type=code&client_id=433687576362&redirect_uri=https://www.dashboard.causalfunnels.com/integration/mailchimp');
  }
  return (
    <div className="relative">
      <div className="bg-gray-800/30 text-black  w-[100%] min-h-[500px] p-5 absolute inset-0 z-10 ">
        <div className="flex items-center justify-center h-full">
          <div className="bg-white rounded-md p-3 basis-2/3 relative">
            <RxCross2
              className="absolute right-3 hover:cursor-pointer"
              onClick={() => setOpen(false)}
            />
            <h2 className="text-2xl font-semibold my-3 mb-4">
              Create a new authentication
            </h2>
            <div className="flex flex-col">
              <label className="text-semibold">Your authentication name</label>
              <input
                type="text"
                value={authName}
                className="rounded-md text-sm border-gray-200 text-gray-500"
                onChange={(e) => setAuthName(e.target.value)}
              />
            </div>

            <div className="mt-20 space-x-3 flex justify-end ">
              <button
                className="text-gray-800 rounded-md p-2 px-3 border hover:text-indigo-600 hover:shadow-lg"
                onClick={() => setOpen(false)}
              >
                Cancel
              </button>
              <button onClick={AuthHandler} className="text-white rounded-md bg-indigo-600 p-2 px-3 hover:bg-indigo-500">
                Create
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthModal;
